// Copyright (c) 2026 GLOBAL MICRO IT TECHNOLOGY SOLUTIONS LIMITED
// Company No. 758762, Dublin, Ireland
// All rights reserved. Proprietary and confidential.

// Per-agent identity and configuration — the single source of per-agent
// literals. Hoisting these here keeps the [GENERIC] shell files (hooks,
// components) byte-identical across all GMS agent web apps so they can be
// hash-verified by the cross-repo sync graph (.claude/shared-frontend.json).
// See Shared-CSS-Reference v3.1 §3 and gms/Cloud-Adoption-Agent#221.
//
// This file is [PER-AGENT] — every agent has its own copy; it is never synced.

export interface AgentConfig {
  /** kebab-case slug — drives storage-key prefixes (`{slug}-agent-{feature}`). */
  agentSlug: string;
  /** Human-readable agent name (shell header, login screen). */
  agentName: string;
  /** MSAL SPA application (client) id — the JWT audience. */
  msalClientId: string;
  /** Locales the i18n bundle ships, BCP-47. First entry is the default. */
  locales: readonly string[];
}

export const agentConfig: AgentConfig = {
  agentSlug: 'cloud-adoption',
  agentName: 'Cloud Adoption Agent',
  msalClientId: '3a79bac2-11f0-4168-a61a-ef3a4c539d0b',
  locales: ['en-GB'],
};
